import CenteredContent from '@picsart/rc/old/CenteredContent';
import classNames from 'classnames';

import useStyles from './styles';

import type { layoutType } from './types';

function BlocksOnBackgroundSkeleton({ type }: { type: layoutType }) {
  const styles = useStyles({ type });
  return (
    <CenteredContent className={styles.root}>
      <div className={styles.skeletonWrapper} data-testid="blocksOnbackground-fallback">
        <div className={styles.skeletonTitle}>
          <i className="skeleton" />
        </div>
        <div className={styles.skeletonDescription}>
          <i className="skeleton" />
        </div>
        <ul className={classNames(styles.summaryList, styles.skeletonSummaryList)}>
          <i className="skeleton" />
          <i className="skeleton" />
          <i className="skeleton" />
          {type === 'twoColumnLayout' && <i className="skeleton" />}
        </ul>
      </div>
    </CenteredContent>
  );
}

export default BlocksOnBackgroundSkeleton;
